import { memo } from "react";
import { Upload } from "lucide-react";
import { useTranslation } from "react-i18next";
import appConfiguration from "@/components/cfg/AppCfg";
import { FileDragHandlers } from "@/hooks/useFileDragAndDrop";
import { ALLOWED_TYPES_DISPLAY } from "@/constants";

interface ContractorCardFileDropZoneProps {
  isDragging: boolean;
  dragHandlers: FileDragHandlers;
  onClick: () => void;
}

export const ContractorCardFileDropZone = memo(
  ({ isDragging, dragHandlers, onClick }: ContractorCardFileDropZoneProps) => {
    const { t } = useTranslation();

    return (
      <div
        className={`text-center py-12 border-2 border-dashed rounded-lg transition-colors ${
          isDragging
            ? "border-primary bg-primary/5"
            : "border-muted-foreground/25"
        }`}
        {...dragHandlers}
        onClick={onClick}
      >
        <Upload className="w-8 h-8 mx-auto mb-2 text-muted-foreground" />
        <p className="text-sm text-muted-foreground">
          {t("contractorCards.messages.dropZone")}
        </p>
        <p className="text-xs text-muted-foreground mt-1">
          {ALLOWED_TYPES_DISPLAY} (max {appConfiguration.maxFileSizeMB}MB)
        </p>
      </div>
    );
  },
);
